import styled from 'styled-components';

const LinkStyled = styled.a`
  width: 100%;
  display: flex;
  align-items: center;
  margin: 0 auto;
  padding-bottom: 18px;
  border-bottom: 1px solid rgba(203,61,66,.59);
  margin-bottom: 19px;
  text-decoration: none;
  cursor: pointer;

  img {
    display: block;
    width: 100%;
    max-width: 25px;
    margin-right: 6px;
  }

  p {
    color: #707070;
    font-size: 12px;
    font-weight: 400;
    margin: 0;
  }
`;

const ButtonBack = (props) => {
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <LinkStyled {...props}>
      <img className="login__back-img" src="https://zonasul.vtexassets.com/arquivos/voltar-background-vermelho.svg" alt="Botão voltar" />
      <p className="login__back-text">Voltar</p>
    </LinkStyled>
  )
}

export default ButtonBack;
